import { X, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Loader } from '@dreamtree-org/twreact-ui';

/**
 * "Specification" — the graph exactly as it will be stored, plus the live lint result.
 *
 * The lint comes from POST /api/workflows/validate, which runs the SAME validateGraph the
 * model hook and the engine call. That endpoint shipped with the feature and nothing ever
 * called it, so until now the only way to discover a cycle or an unreachable node was to
 * hit Save and read the 400.
 */

const panelClass = 'h-full w-96 shrink-0 flex flex-col rounded-md border border-[var(--app-border)] bg-[var(--app-surface)] overflow-hidden';

export default function SpecPanel({ spec, validation, validating, onClose }) {
  return (
    <div className={panelClass}>
      <div className="flex items-center justify-between px-3 py-2 border-b border-[var(--app-border)]">
        <span className="text-sm font-semibold">Specification</span>
        <button type="button" onClick={onClose} aria-label="Close" className="p-1 rounded text-secondary-500 hover:text-primary-600">
          <X size={14} />
        </button>
      </div>

      <div className="px-3 py-2 border-b border-[var(--app-border)] text-xs">
        {validating && <Loader text="Checking…" />}
        {!validating && validation?.ok && (
          <span className="flex items-center gap-1 text-emerald-600">
            <CheckCircle2 size={13} />
            Valid — {validation.nodes} nodes, {validation.edges} edges, entry <code className="font-mono">{validation.entryId}</code>
          </span>
        )}
        {!validating && validation && !validation.ok && (
          <span className="flex items-start gap-1 text-red-600">
            <AlertTriangle size={13} className="mt-0.5 shrink-0" />
            <span>{validation.error}</span>
          </span>
        )}
      </div>

      <pre className="flex-1 overflow-auto p-2.5 text-[11px] font-mono leading-relaxed">
        {JSON.stringify(spec, null, 2)}
      </pre>
    </div>
  );
}
